import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagCambioFechaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagCambioFecha'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagCambioFecha'
          label='Cambio Fecha'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagCambioFechaFormGroup)
